export enum EnumTipoArquivo {
    Remessa,
    Retorno,
    NFe
}